import { render, staticRenderFns } from "./filter-categories.vue?vue&type=template&id=684c55e7"
import script from "./filter-categories.vue?vue&type=script&lang=js"
export * from "./filter-categories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports